module.exports = __webpack_public_path__ + "static/img/rank_background.b1eef5d2.png";